import { createReducer, on } from "@ngrx/store";
import { User } from "../../models/user.model";
import { userActions } from "./user.actions";

export interface UserState {
    users: User[]|null,
    state: 'pending'|'loading'|'loaded'|'error'
}

export const initialState: UserState = {
    users: null,
    state: 'pending'
};

export const userReducer = createReducer(
    initialState,
    on(userActions.loadUsers, (state) => ({
        ...state,
        users: null,
        state: 'loading' as const
    })),
    on(userActions.loadUsersSuccess, (state, {payload}) => ({
        ...state,
        users: payload,
        state: 'loaded' as const
    })),
    on(userActions.loadUsersFail, (state) => ({
        ...state,
        users: null,
        state: 'error' as const
    }))
)